import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import Box from "@mui/material/Box";
// Lazy load Admin area to avoid pulling it into initial bundle
const AdminArea = React.lazy(() => import("../Admin/AdminArea"));

interface IAdminListItemsProps {
  setButtonClick: (button: JSX.Element) => void;
}

const AdminListItems = (props: IAdminListItemsProps) => {
  const loadAdmin = () => {
    props.setButtonClick(<AdminArea />);
  };
  return (
    <Box sx={{"& .MuiListItemButton-root":{mx:.5,borderRadius:1.5,transition:"background-color 160ms ease, transform 160ms ease, box-shadow 160ms ease"},"& .MuiListItemButton-root:hover":{bgcolor:"action.selected",transform:"translateX(2px)",boxShadow:1},"& .MuiListItemButton-root:active":{bgcolor:"action.selected",boxShadow:2}}}>
      <React.Fragment>
        <ListSubheader component="div" inset>
          Admin
        </ListSubheader>
        <ListItemButton onClick={loadAdmin}>
          <ListItemIcon>
            <AdminPanelSettingsIcon
              sx={{ color: (theme) => theme.palette.error.light }}
            />
          </ListItemIcon>
          <ListItemText primary="Employees" />
        </ListItemButton>
      </React.Fragment>
    </Box>
  );
};
export default AdminListItems;
